export class RouteUrl {
  static welcome = "/";
  static requestDeleteAccount = "/request-delete-account";
  static sendRequestFeedback = "/send-request-feedback";
  static receiveRequestFeedback = "/receive-request-feedback";
  static notFound = "*";
  static login = "/login";
  static forgotPasswordPhone = "/forgot-password-phone";
  static changePassword = "/change-password";
  static deleteAccount = "/delete-account";
  static resetPassword = "/reset-password";
  static interestingCategory = "/interesting-category";
  static forgotPasswordEmail = "/forgot-password-mail";
  static signUp = "/sign-up";
  static dashboard = "/dashboard";
  static shopMenu = "/ffp/menu";
  static shopClockTime = "/ess/attendance";
  static termOfPrivacy = "/term-of-privacy";
  static termOfServices = "/term-of-services";
  static publicProfile = "/profile";
  static viewShop = "/view-shop";
  static viewProduct = "/view-product";
  static profilePostContentsPageView = "/post";
  static following = "/following";
  static forme = "/forme";
  static newsFeed = "/news-feed";
  static viewStories = "/view-stories";
  static marketPlaces = "/marketplaces";
  static profile = "/profile";
  static viewProfile = "/view-profile";
  static ProfileDetail = "/profile-detail";
  static setting = "/setting";
  static chat = "/chat";
  static businessSuite = "/shop-detail";
  static blockAccount = "/block-account";
  static boringAccount = "/boring-account";
  static loggedDevices = "/logged-devices";
  static requestVerificationAccount = "/request-verification-account";
  static soundLibraries = "/sound-libraries";
  static desActivateAccount = "/desactivate-account";
  static deletePageStatus = "/delete-page-status";
  static disactivatePageStatus = "/desactivate-page-status";
  static changePasswordPageStatus = "/change-password-page-status";
  static interesting = "/interesting";
  static switchAccount = "/switch-account";
  static language = "/language";
  static productService = "/product-service";
  static timeSheet = "/time-sheet";
  static staff = "/staff";
  static musicLibraries = "/music-libraries";
  static campaigns = "/campaigns";
  static leads = "/leads";
  static opportunities = "/opportunities";
  static jobs = "/jobs";
  static events = "/events";
  static projects = "/projects";
  static accountDashboard = "/account-dashboard";
  static testing = "/mengkorng";
  static tools = "/tools";
  static accuonttools = "/accuont-tools";
  static toolsAccount = "/tools-account";
  static SuggestionSearch = "/search";
  static liveStudio = "/live-studio";
  static payroll = "/payroll";
  static leave = "/leave";
  static request = "/request";
  static calendar = "/calendar";
}
